/**
 * Created by Andrey Popov on 10.11.2021
 */

const TextureImage = function (atlasAnalyzer) {
    this.atlasAnalyzer = atlasAnalyzer;

    cleverapps.EventEmitter.call(this);

    this.textureMap = undefined;
    this.asset = undefined;
    this.selectedTextureFrame = undefined;

    this.atlasAnalyzer.bundlesExplorer.on("selectionChanged", this.selectTab.bind(this));
};

TextureImage.prototype = Object.create(cleverapps.EventEmitter.prototype);
TextureImage.prototype.constructor = TextureImage;

TextureImage.prototype.isIllustrationOnly = function (selectedItem) {
    const { urls } = bundles[selectedItem];
    const asset = urls.png || urls.particle_texture || urls.illustration;

    return urls.illustration != null && asset === urls.illustration;
};

TextureImage.prototype.selectTab = function (tab, selectedItem, frameToSelect) {
    this.selectedItem = selectedItem;
    this.frameToSelect = frameToSelect;

    tab = !tab && this.isIllustrationOnly(this.selectedItem)
        ? TextureImage.TABS.ILLUSTRATION
        : TextureImage.TABS.TEXTURE;

    this.trigger("selectTab", tab);
};

TextureImage.prototype.onSelectionChanged = function (tab) {
    this.trigger("showLoading");

    this.textureMap = undefined;
    this.asset = undefined;

    new ActionPlayer([
        (f) => {
            const bundle = bundles[this.selectedItem];
            if (!bundle || bundle.meta.virtualDebugBundle) {
                this.prepareVirtualDebugBundle(this.selectedItem, f);
            } else {
                f();
            }
        },

        (f) => {
            const urls = bundles[this.selectedItem].listUrls();

            cc.loader.load(urls, (status) => {
                if (status) {
                    console.error("load failed: ", this.selectedItem);
                    this.trigger("hideLoading");
                    return;
                }
                f();
            });
        },

        (f) => {
            const bundle = bundles[this.selectedItem];

            if (bundle.urls.json && bundle.jsons.debug_meta_json) {
                const textureJsons = cc.loader.getRes(bundle.urls.json) || cc.loader.getRes(bundle.urls.json.getUrl());
                Object.assign(bundle.meta, textureJsons && textureJsons[bundle.jsons.debug_meta_json.name] || {});
            }

            f();
        },

        (f) => {
            if (tab === TextureImage.TABS.ILLUSTRATION) {
                this.showIllustration(this.selectedItem);
            } else {
                this.showTexture(this.selectedItem, this.frameToSelect);
            }

            f();
        }
    ]).play();
};

TextureImage.prototype.prepareVirtualDebugBundle = function (bundleName, callback) {
    cleverapps.RestClient.get(`/pack/${bundleName}`, {}, (response) => {
        const resolutionName = cleverapps.resolution.resolutionName;

        const selectResolution = function (obj) {
            for (const key in obj) {
                const value = obj[key];
                if (value[resolutionName]) {
                    obj[key] = value[resolutionName];
                }
            }
        };

        const selectUrls = function (urls) {
            for (const key in urls) {
                urls[key] = `//${location.host}${cleverapps.isLocalhost() ? `/${cleverapps.config.name}` : ""}/${urls[key]}`;
            }
        };

        selectResolution(response.frames);
        selectResolution(response.urls);
        selectUrls(response.urls);

        console.log("prepareVirtualDebugBundle success: ", response);

        bundles[bundleName] = new Bundle(bundleName, response);

        callback();
    }, (error) => {
        console.log("prepareVirtualDebugBundle error: ", error);
        callback();
    });
};

TextureImage.prototype.showIllustration = function (selectedItem) {
    const bundle = bundles[selectedItem];

    this.asset = bundle.urls.illustration;

    if (!this.asset) {
        this.trigger("removeData");
        this.trigger("hideLoading");
        return;
    }

    const data = { ...this.asset };

    this.calculateAssetLinks(selectedItem, data, { illustration: true });
    data.size = cc.loader.getRes(this.asset).getContentSize();

    this.trigger("showAsset", this.asset);
    this.trigger("showIllustration", data);
};

TextureImage.prototype.showTexture = function (selectedItem, frameToSelect) {
    const bundle = bundles[selectedItem];

    this.asset = bundle.urls.png || bundle.urls.particle_texture;

    this.trigger("showAsset", this.asset);
    if (!bundle.urls.json || !this.asset) {
        this.trigger("removeData");
        this.trigger("hideLoading");
        return;
    }

    const textureJsons = cc.loader.getRes(bundle.urls.json) || cc.loader.getRes(bundle.urls.json.getUrl());

    if (!bundle.jsons.atlas || !textureJsons[bundle.jsons.atlas.name]) {
        return;
    }

    this.textureMap = this.parseAtlas(selectedItem, textureJsons[bundle.jsons.atlas.name]);

    if (!this.textureMap) {
        console.error("missing description for ", selectedItem);
        return;
    }

    this.textureMap.texture.byteSize = bundle.meta.textureSize && bundle.meta.textureSize[cleverapps.resolution.resolutionName] || "";

    this.textureMap.frames.forEach((frame) => {
        this.calculateAssetLinks(selectedItem, frame);
    });

    if (this.textureMap.frames.length > 0) {
        let selectedFrame = this.textureMap.frames[0];
        if (frameToSelect) {
            const candidates = this.textureMap.frames.filter((frame) => frame.name === frameToSelect);
            if (candidates.length > 0) {
                selectedFrame = candidates[0];
            }
        }
        
        this.trigger("selectTextureFrame", selectedFrame, true);
    }
};

TextureImage.prototype.parseAtlas = function (name, atlas) {
    atlas = BundleUtils.parseAtlas(atlas);

    const map = {
        texture: {
            name,
            fileName: atlas.meta.image,
            size: {
                width: atlas.meta.size.w,
                height: atlas.meta.size.h
            }
        },
        frames: []
    };

    const nameKeys = {};

    for (const frameKey in bundles[name].frames) {
        nameKeys[bundles[name].frames[frameKey].name] = frameKey;
    }

    Object.keys(atlas.frames).forEach((filename) => {
        const frame = atlas.frames[filename];
        map.frames.push({
            name: filename,
            key: nameKeys[filename],
            position: cc.p(frame.rect.x, atlas.meta.size.h - frame.rect.y),
            size: frame.rotated ? cc.size(frame.rect.height, frame.rect.width)
                : cc.size(frame.rect.width, frame.rect.height)
        });
    });

    return map;
};

TextureImage.prototype.calculateAssetLinks = function (bundleName, asset, options) {
    options = options || {};

    const originalPaths = bundles[bundleName].meta.originalPaths;
    const unused = bundles[bundleName].unused || {};

    let link;

    if (options.illustration) {
        link = originalPaths.illustration;
    } else {
        link = (asset && asset.name && originalPaths[asset.name])
            || (asset && asset.key && originalPaths[asset.key])
            || (asset && asset.name && originalPaths[asset.name.replace(".png", ".jpg")]);
    }

    if (!link) {
        return;
    }

    const unpackedName = link.split("/").pop();

    let repo = link.substring(0, link.indexOf("/"));
    let linkWithoutRepo = link.substring(link.indexOf("/"));
    if (repo === "res") {
        repo = cleverapps.config.name;
        linkWithoutRepo = link;
    }

    asset.unpackedName = unpackedName;
    asset.link = link;
    asset.gitLink = `https://github.com/Clever-Apps-Pte-Ltd/${repo}/tree/master/${linkWithoutRepo}`;

    if (!options.illustration) {
        asset.unused = (asset && asset.name && unused[asset.name])
            || (asset && asset.key && unused[asset.key])
            || (asset && asset.name && unused[asset.name.replace(".png", ".jpg")]);
    }
};

TextureImage.prototype.handleTextureClick = function (x, y) {
    if (!this.textureMap) {
        return;
    }

    for (let i = 0; i < this.textureMap.frames.length; i++) {
        const frame = this.textureMap.frames[i];

        if (x >= frame.position.x && x <= frame.position.x + frame.size.width
            && y >= frame.position.y - frame.size.height && y <= frame.position.y) {
            this.selectFrame(frame);
            break;
        }
    }
};

TextureImage.prototype.selectFrame = function (frame, animate) {
    this.selectedTextureFrame = frame;
    this.trigger("selectTextureFrame", frame, animate);

    cleverapps.setUrlHash({
        atlasAnalyzer: true,
        tab: this.atlasAnalyzer.bundlesExplorer.selectedTab,
        bundleName: this.atlasAnalyzer.bundlesExplorer.selectedItem,
        frame: frame.name
    });
};

TextureImage.prototype.clear = function () {
    this.trigger("clear");

    delete this.textureMap;
    delete this.asset;
    delete this.selectedTextureFrame;
    delete this.selectedItem;
    delete this.frameToSelect;
};

TextureImage.TABS = {
    TEXTURE: "Texture",
    ILLUSTRATION: "Illustration"
};
